<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-09 15:21:25
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-01-11 15:37:17
 * @name: 自定义普通弹窗
 * @Description: 自定义普通弹窗
 * @FilePath: \preSaleNafterSaleBackstage\src\components\public\dialog-normal.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div class="dialogNormal" v-if="dialogVisible" @click="close">
    <div class="content">
      <div class="card" :style="{ width }" @click.stop>
        <div class="head">
          <font>{{ title }}</font>
        </div>
        <div class="main">
          <slot name="main" />
        </div>
        <div class="foot">
          <slot name="foot" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "dialogNormal",
  props: {
    width: {
      type: String,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dialogVisible: false, //弹窗显隐
    };
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开dialog
     */
    open() {
      this.dialogVisible = true;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 关闭dialog
     */
    close() {
      this.$emit("close");
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.dialogNormal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: $Var-floating-color;
  z-index: 1999;
  overflow-y: auto;
  .content {
    padding: 30px 0;
    width: 100%;
    min-height: 100%;
    box-sizing: border-box;
    @extend .extend-flex-center;
    .card {
      background: white;
      border-radius: $Vars-border-radius-normal;
      box-shadow: $Vars-boxShadow-simple;
      border: 1px solid $Vars-info-color;
      .head {
        width: 100%;
        height: 40px;
        @extend .extend-flex-center;
        font-size: $Vars-font-title-size;
        border-bottom: 1px solid $Vars-border-first-color;
      }
      .main {
        width: 100%;
        padding: 10px 20px;
        box-sizing: border-box;
      }
      .foot {
        width: 100%;
        padding: 15px 0;
        @extend .extend-flex-center;
      }
    }
  }
}
</style>
